// import { handleThemeDark } from "src/shared/StylesTheme/ThemeDark";
import { handleLightTheme } from "src/shared/StylesTheme/ThemeLight";

export const UseSetColorPrimary = () => {
  // const [themeDark] = handleThemeDark();
  const [LightTheme] = handleLightTheme();

  return [LightTheme];
};
